import React from 'react'
import { Text, Button } from '@theneatcompany/nui'
import Image from 'next/image'

import { useAccounts } from '@/components/Providers/AccountsProvider'
import { useUtils } from '@/components/Providers/UtilsProvider'
import Link from '@/components/common/Link'
import { ROUTES } from '@/constants'
import NeatLogoSvg from '@/assets/svg/NeatLogo.svg'

import styles from './Header.module.scss'

export default function Header() {
  const { user } = useAccounts()
  const { sidebar: { setCollapsed } } = useUtils()

  return (
    <header id="header" className={styles.container}>
      <div className={styles.menu}>
        <Button
          variant="secondary"
          iconOnly
          iconProps={{ name: 'hamburger', title: 'menu' }}
          onClick={() => setCollapsed(c => !c)}
        />
      </div>

      <div className={styles.logo}>
        <Link to={ROUTES.overview}>
          <Image src={NeatLogoSvg} width={87} height={23} alt="Neat Logo" priority />
        </Link>
      </div>

      <div className={styles.userInfo}>
        <Text className={styles.name} typeStyle="bold" color="tint-brand-primary">{user.firstName} {user.lastName}</Text>
        <Text className={styles.email} color="foreground-secondary">{user.email}</Text>
      </div>
    </header>
  )
}
